import { InjectionToken } from '@angular/core';
import { TimeSheetReportsPort } from './time-sheet-reports.port';

export const TIMESHEET_PORT = new InjectionToken<TimeSheetReportsPort>('TIMESHEET_REPORTS_PORT');